import React from 'react';
import '../../utils/assertions.es.js';
import { maestroComponent } from '../../utils/componentHelpers.es.js';
import '../../utils/responsive.es.js';
import '../../utils/scrollIntoView.es.js';
import 'polished';
import '@styled-system/css';
import 'styled-components';
import '../../utils/useEnhancedEffect.es.js';
import 'react-is';
import { Popper } from '../../primitives/Popper/Popper.es.js';
import { Fade } from '../Fade/Fade.es.js';
import { Container } from './styled.es.js';

var __defProp = Object.defineProperty;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const Component = (_a) => {
  var _b = _a, {
    children,
    hasArrow = false,
    isOpen = false,
    onClose,
    onOpen,
    placement = "bottom",
    offset = [0, 16],
    anchorRef,
    triggerRef,
    size = "auto",
    disablePortal,
    usePortal = true,
    onClickOutside,
    isLazy,
    zIndex = 1e3
  } = _b, props = __objRest(_b, [
    "children",
    "hasArrow",
    "isOpen",
    "onClose",
    "onOpen",
    "placement",
    "offset",
    "anchorRef",
    "triggerRef",
    "size",
    "disablePortal",
    "usePortal",
    "onClickOutside",
    "isLazy",
    "zIndex"
  ]);
  return /* @__PURE__ */ React.createElement(Popper, {
    onClose,
    onOpen,
    isOpen,
    anchorRef,
    triggerRef,
    transitionComponent: Fade,
    popperOptions: {
      placement,
      modifiers: [
        {
          name: "offset",
          options: {
            offset
          }
        }
      ]
    },
    disablePortal,
    usePortal,
    onClickOutside,
    zIndex,
    isLazy
  }, /* @__PURE__ */ React.createElement(Container, __spreadValues({
    role: "dialog",
    size
  }, props), children, hasArrow && /* @__PURE__ */ React.createElement(Popper.Arrow, null)));
};
Component.displayName = "PopoverBase";
const PopoverBase = maestroComponent("PopoverBase", Component);

export { PopoverBase };
//# sourceMappingURL=PopoverBase.es.js.map
